import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { BreadcrumbService } from '../../core/service/breadcrumb.service';
import { Router } from '@angular/router';
import { AuthGuard } from '../../core/guard/auth.guard';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  isMobile = false; // Flag to check if the device is mobile
  isDropdownOpen = false;
  showCloseIcon: boolean = false;
  driverName: String = '';
  isFormSubmitted: boolean = false;

  constructor(private breadcrumbService: BreadcrumbService, private el: ElementRef, private route: Router, private authGuard: AuthGuard, private http: HttpClient) { }
  ngOnInit() {
    console.log(this.isDropdownOpen);
    this.driverName = this.breadcrumbService.getDriverName();
    this.checkDevice();
    this.breadcrumbService.formSubmitted$.subscribe((value) => {
      if (value) {
        this.isFormSubmitted = true;
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkDevice();
  }

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    const target = event.target as HTMLElement;

    // Close only if the click is outside the dropdown
    if (!target.closest('.user-icon')) {
      this.isDropdownOpen = false;
      this.showCloseIcon = false;
    }
  }

  // Close the side nav if clicked outside
  onDocumentClick = (event: MouseEvent): void => {
    if (this.el.nativeElement && !this.el.nativeElement.contains(event.target)) {
      console.log('entered close event')
      this.showCloseIcon = false; // Close the side nav
    }
  };


  private checkDevice() {
    this.isMobile = window.innerWidth <= 768; // Mobile breakpoint
  }

  // Emit an event to open the side nav
  toggleSideNav(event: MouseEvent): void {

    event.stopPropagation(); // to prevent the control to transfer to the side nav coomponent 'prevent hte event from reaching the document'

    this.breadcrumbService.openSideNav();
    this.showCloseIcon = !this.showCloseIcon;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    console.log(this.isDropdownOpen);
  }

  logout() {
    this.authGuard.authenticateUser(0);
    this.route.navigate(['/login']);
    this.breadcrumbService.setActiveStep(0);
  }

  playHoverAnimation(event: Event) {
    const target = event.target as HTMLElement;
    target.classList.add('hover-animate');
    target.addEventListener('animationend', () => {
      target.classList.remove('hover-animate');
    });
  }



}